import React, { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { PageLoading } from '@/components/ui/loading';

/** Full-page loading state using app loading component. */
function AuthLoading() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-nb-bg">
      <PageLoading message="Loading…" />
    </div>
  );
}

type RequireAuthProps = { children?: ReactNode };

/**
 * Layout route: only renders child routes when authenticated.
 * - isLoading: full-page spinner
 * - !isAuthenticated: redirect to /login
 * - else: render nested routes via Outlet
 */
export default function RequireAuth(_props: RequireAuthProps = {}) {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return <AuthLoading />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
